import { render, staticRenderFns } from "./AddRoleCard.vue?vue&type=template&id=2229813e&scoped=true&"
import script from "./AddRoleCard.vue?vue&type=script&lang=js&"
export * from "./AddRoleCard.vue?vue&type=script&lang=js&"
import style0 from "./AddRoleCard.vue?vue&type=style&index=0&id=2229813e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2229813e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})


/* hot reload */
if (module.hot) {
  var api = require("/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2229813e')) {
      api.createRecord('2229813e', component.options)
    } else {
      api.reload('2229813e', component.options)
    }
    module.hot.accept("./AddRoleCard.vue?vue&type=template&id=2229813e&scoped=true&", function () {
      api.rerender('2229813e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/role/AddRoleCard.vue"
export default component.exports